/**
 * @generated SignedSource<<83c0c5bf18e35c0db67c88e8c85855b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeUpdateInput = {
  setEmail?: string | null;
  setImageId?: string | null;
  setName?: string | null;
};
export type EmployeeEditSaveEmployeeMutation$variables = {
  employeeId: string;
  input: EmployeeUpdateInput;
};
export type EmployeeEditSaveEmployeeMutation$data = {
  readonly employee: {
    readonly update: {
      readonly id: string;
      readonly image: {
        readonly " $fragmentSpreads": FragmentRefs<"ImagePublicOrPrivate_image">;
      } | null;
      readonly name: string;
    };
  } | null;
};
export type EmployeeEditSaveEmployeeMutation$rawResponse = {
  readonly employee: {
    readonly update: {
      readonly id: string;
      readonly image: {
        readonly __typename: "Image";
        readonly __isPublicAndInternalImage: "Image";
        readonly id: string;
        readonly sizes: ReadonlyArray<{
          readonly height: number;
          readonly id: string;
          readonly url: string;
          readonly urlExpiresAt: string | null;
          readonly width: number;
        }>;
        readonly thumbhash: string | null;
      } | {
        readonly __typename: "PublicImage";
        readonly __isPublicAndInternalImage: "PublicImage";
        readonly publicImageUrl: string;
      } | {
        readonly __typename: string;
        readonly __isPublicAndInternalImage: string;
      } | null;
      readonly name: string;
    };
  } | null;
};
export type EmployeeEditSaveEmployeeMutation = {
  rawResponse: EmployeeEditSaveEmployeeMutation$rawResponse;
  response: EmployeeEditSaveEmployeeMutation$data;
  variables: EmployeeEditSaveEmployeeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "employeeId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeEditSaveEmployeeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "EmployeeMutation",
        "kind": "LinkedField",
        "name": "employee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ImagePublicOrPrivate_image"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EmployeeEditSaveEmployeeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "EmployeeMutation",
        "kind": "LinkedField",
        "name": "employee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isPublicAndInternalImage"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publicImageUrl",
                        "storageKey": null
                      }
                    ],
                    "type": "PublicImage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbhash",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlExpiresAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "height",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "width",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Image",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "55cbd61ec34d0db79571e44ec45b3ddd",
    "id": null,
    "metadata": {},
    "name": "EmployeeEditSaveEmployeeMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeEditSaveEmployeeMutation(\n  $input: EmployeeUpdateInput!\n  $employeeId: ID!\n) {\n  employee(id: $employeeId) {\n    update(input: $input) {\n      id\n      name\n      image {\n        __typename\n        ...ImagePublicOrPrivate_image\n        ... on Image {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n"
  }
};
})();

(node as any).hash = "d328d4674612dc7e4666d2064e3cf869";

export default node;
